const UPDATE_GAME_STATE = 'gameState/UPDATE_GAME_STATE';

export const defaultState = {
    hasNewUnlockTaskPrize: false,
    gameResultRecordsCount: 0,
    hasLotteryTaskMappingEntryInited: false,
    lotteryTaskMappingEntry: {}
};
const reducer = (state = defaultState, action) => {
    switch (action.type) {
        case UPDATE_GAME_STATE:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};

export default reducer;

export function setHasNewUnlockTaskPrize(status) {
    return {
        type: UPDATE_GAME_STATE,
        payload: {
            hasNewUnlockTaskPrize: status
        }
    };
}

export function updateGameResultRecordsCount() {
    return (dispatch, getState) => {
        const { userGameResultRecords } = getState();
        dispatch({
            type: UPDATE_GAME_STATE,
            payload: {
                gameResultRecordsCount: userGameResultRecords.length
            }
        });
    };
}

export function setLotteryTaskMappingEntryInited() {
    return {
        type: UPDATE_GAME_STATE,
        payload: {
            hasLotteryTaskMappingEntryInited: true
        }
    };
}

export function setLotteryTaskMappingEntry(lotteryTaskMappingEntry) {
    return {
        type: UPDATE_GAME_STATE,
        payload: {
            lotteryTaskMappingEntry
        }
    };
}
